export const TIPOS_MARGEN_REQUEST = "TIPOS_MARGEN_REQUEST";
export const TIPOS_MARGEN_OK = "TIPOS_MARGEN_OK";
export const TIPOS_MARGEN_ERROR = "TIPOS_MARGEN_ERROR";
